export default __webpack_public_path__ + "static/media/org2.afb98d67.png";